export default "__VITE_ASSET__BgbaDv3I__"